'use client';
import Button from '@/components/Button';
import Drowdown from '@/components/Dropdown/Dropdown';
import Input from '@/components/Input';
import Radio from '@/components/Radio/Radio';
import PlusCircle from '@/components/icons/PlusCircle';
import { Footer } from '@/containers';
import useNavigate from '@/hooks/useNavigate';
import {
  useGetListEmployersQuery,
  useLazyGetEmployerQuery,
} from '@/services/API';
import { useAppDispatch } from '@/store/hooks';
import { setSte } from '@/store/slices/steSlice';
import { IEmployer } from '@/types';
import { useEffect, useState } from 'react';
import styles from './page.module.css';

export default function Home() {
  const [isDisabled, setIsDisabled] = useState(true);
  const [selectedValue, setSelectedValue] = useState('STE');
  const [inputValue, setInputValue] = useState('');
  const [sirenSearchError, setSirenSearchError] = useState('');
  const [dropdownChoice, setDropdownChoice] = useState<IEmployer>();
  const { data: employers } = useGetListEmployersQuery();
  const [getEmployer] = useLazyGetEmployerQuery();

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const processChoice = (value: IEmployer) => {
    dispatch(setSte(value));
  };

  const radioValues = [
    { text: 'À partir d’une société', value: 'STE' },
    { text: ' À partir d’un SIREN', value: 'SIREN' },
  ];

  const handleSubmit = () => {
    switch (selectedValue) {
      case 'SIREN':
        getEmployer(inputValue)
          .unwrap()
          .then((payload) => {
            if (payload) {
              processChoice(payload);
              navigate('menu');
            } else setSirenSearchError("Ce SIREN n'existe pas");
          });
        break;
      case 'STE':
        if (dropdownChoice) {
          processChoice(dropdownChoice);
          navigate('menu');
        }
        break;
      default:
    }
  };

  useEffect(() => {
    if (selectedValue === 'STE') {
      setDropdownChoice(undefined);
    }
  }, [selectedValue]);

  useEffect(() => {
    if (selectedValue === 'SIREN' && inputValue.length === 9)
      setIsDisabled(false);
    else setIsDisabled(true);
  }, [inputValue, selectedValue]);

  useEffect(() => {
    if (selectedValue === 'STE' && dropdownChoice) setIsDisabled(false);
    else setIsDisabled(true);
  }, [dropdownChoice, selectedValue]);

  function pickDropdown() {
    if (selectedValue == 'STE')
      return (
        <Drowdown
          options={[...(employers || [])]
            .sort((a, b) => a.name.localeCompare(b.name))
            .map((employer) => {
              return {
                label: employer.name,
                value: employer.name,
                ...employer,
              };
            })}
          searchable={true}
          placeHolder=""
          onSelectionChange={setDropdownChoice}
          label="La société"
        />
      );

    return (
      <Input
        onChange={(e) => {
          setInputValue(e.target.value);
          setSirenSearchError('');
        }}
        label="Le SIREN"
        value={inputValue}
        maxLength={9}
        errorMessage={sirenSearchError}
      ></Input>
    );
  }
  return (
    <>
      <div className={styles['content']}>
        <div className={styles['top-section']}>
          <div className={styles.title}>
            <h3 className={styles['bigger']}>Créer une société</h3>
          </div>
          <Button
            icon={<PlusCircle />}
            size="medium"
            variant="primary"
            onClick={() => navigate('societe/creer')}
          >
            Ajouter une société
          </Button>
        </div>
        <div className={styles.ou}>
          <hr></hr>
          <p>ou</p>
          <hr></hr>
        </div>
        <div className={styles.administration}>
          <h3 className={styles['bigger']}>Administrer une société</h3>
          <p className="l">(une société est un SIREN)</p>
          <div className={styles.form}>
            <div className={styles['radio-wrapper']}>
              {radioValues.map((value, index) => (
                <Radio
                  key={index}
                  value={value.value}
                  onClick={() => {
                    setSelectedValue(value.value);
                    setSirenSearchError('');
                  }}
                  checked={selectedValue === value.value}
                >
                  <p>{value.text}</p>
                </Radio>
              ))}
            </div>
            {pickDropdown()}
            <div className={styles['button-container']}>
              <Button
                icon={<PlusCircle />}
                variant="primary"
                size="medium"
                disabled={isDisabled}
                onClick={() => handleSubmit()}
              >
                Administrer une société
              </Button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
